import { MarketManagementPage } from '../ConnectorManagement';

export function SkillManagementPage() {
  return <MarketManagementPage itemType="skill" />;
}
